<template>
    <div class="form-container">
        <h2>{{$t('nav.ThirdAccount')}}</h2>
        <div class="auth-tip">{{$t('third.ThirdAccountTip')}}</div>
        <div class="auth-con">
            <div class="third-list" v-for="(item,index) in thirdTypes" :key="'third'+index">
                <div class="third-list-l">
                    <div class="circle"><img :src="item.img" alt=""></div>
                    <div class="circle-name">{{item.name}}</div>
                </div>
                <div class="third-list-r" @click="bind(item,index)">
                    <!-- <span v-if="item.bind" class="bind">{{$t('third.RemoveBound')}}</span>
                    <span v-else>{{$t('home.Bind')}}</span> -->
                    <wd-button  :bordered="true" :styles="btnStyles">{{item.bind?$t('third.RemoveBound'):$t('home.Bind')}}</wd-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import WdButton from "@/components/WdButton.vue";
export default {
    name:'third',
    data(){
        return{
            confirm:{
                show:false,
                conShow:false,
                content:''
            },
            unbind:{},
            unbindIndex:0,
            third_url:'',
            thirdTypes:[],
            user:'',
            btnStyles:{
                width:'100px',
            }
        }
    },
    components:{
        'wd-button':WdButton
    },
    computed:{
        //  thirdTypes(){
        //     let arr = [];
        //     console.log(this.base_configs)
        //     for(var i in this.base_configs.third_login_url){
        //          let name = "QQ";
        //          let type = 1;
        //         switch (i){
        //             case 'qq':
        //                 name = 'QQ';
        //                 type = 2;
        //                 break;
        //             case 'weixin':
        //                 name = '微信';
        //                  type = 1;
        //                 break;
        //             case 'weibo':
        //                 name = '微博';
        //                  type = 3;
        //                 break;
        //             case 'facebook':
        //                 name = 'Facebook';
        //                  type = 4;
        //                 break;
        //             case 'google':
        //                 name = 'Google';
        //                 type = 5;
        //                 break;
        //         }
        //         arr.push({key:i,bind:0,type:type,img:require("../../public/img/login-"+i+".png"),name:name,url:this.base_configs.third_login_url[i]})
        //     }
        //     for(var i=0;i<arr.length;i++){
        //         for(var j=0;j<this.user.third_accounts.length;j++){
        //             let item = this.user.third_accounts[j];
        //             if(item.third_party_type == arr[i].type){
        //                 arr[i].bind = 1;
        //             }
        //         }
        //     }
        //      return arr;
        //  }
    },
    methods:{
        // 解绑
        async unbindConfrim(){
            let postData = {
                type:this.unbind.type,
                jump_code_verify:1
            }
            let res = await this.$api.post('/web/index/unBindThirdParty',postData);
            if(res.code == 0){
                this.$alert(this.$t("third.UnbindSuccess"))
                this.thirdTypes[this.unbindIndex].bind = 0;
                for(var j=0;j<this.user.third_accounts.length;j++){
                    let item = this.user.third_accounts[j];
                    if(item.third_party_type == this.unbind.type){
                        this.user.third_accounts.splice(j,1)
                        this.$setUser({third_accounts:this.user.third_accounts});
                    }
                }
            }
        },
     
        async bind(item,index){
            if(item.bind){
                this.unbind = item;
                this.unbindIndex = index;
                this.unbindConfrim();
            }else{
                for(var i in this.thirdUrl){
                    if(i == item.key){
                        window.open(this.thirdUrl[i], "_blank");
                    }
                }
            }     
        }
    },
    async created(){
        //获取绑定链接
        let res = await this.$api.get('/web/index/getThirdLoginBindUrl');
        if(res.code == 0){
            this.thirdUrl = res.data;  
        }
        this.from = this.$route.query.from || '';
        let user = await this.$getUser(this.from);
        let {base_configs} = await this.$getAppBaseData();  
        this.user = user;
        this.base_configs = base_configs;

        let arr = [];
        for(var i in base_configs.third_login_url){
            let name = "QQ";
            let type = 1;
            switch (i){
                case 'qq':
                    name = 'QQ';
                    type = 2;
                    break;
                case 'weixin':
                    name = '微信';
                        type = 1;
                    break;
                case 'weibo':
                    name = '微博';
                        type = 3;
                    break;
                case 'facebook':
                    name = 'Facebook';
                        type = 4;
                    break;
                case 'google':
                    name = 'Google';
                    type = 5;
                    break;
            }
            arr.push({key:i,bind:0,type:type,img:require("../../public/img/login-"+i+".png"),name:name,url:base_configs.third_login_url[i]})
        }
        for(var i=0;i<arr.length;i++){
            for(var j=0;j<user.third_accounts.length;j++){
                let item = user.third_accounts[j];
                if(item.third_party_type == arr[i].type){
                    arr[i].bind = 1;
                }
            }
        }
        this.thirdTypes = arr;
        
    }
}
</script>
<style scoped>
    .auth-tip{
        color: #666;
        font-size: 14px;
        margin-bottom: 10px;
        text-align: center;
    }
    .auth-con .third-list{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background-color: #f6f6f6;
        border-radius: 5px;
        padding: 10px 20px;
        margin-bottom: 10px;
    }
    .third-list .third-list-l{
        display:flex;
        align-items: center
    }
    .third-list-l .circle{
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 1px solid #818599;
        padding: 3px;
        box-sizing: border-box;
        margin-right: 30px;
        text-align: center;
    }
    .third-list-l .circle-name{
        color: #333;
        font-size: 20px;
    }
    .third-list-l .circle img{
        width: 100%;
        height: 100%;
         border-radius: 50%;
        background-color: #818599;
        padding: 10px;
        box-sizing: border-box

    }
</style>
